<template>
  <div class="l-top-bar _page">
    <div class="_container container">
      <div class="logo">
        <a href="/home" class="icon"></a>
      </div>

      <nav class="nav-bar">
        <span v-for="item of routerConf" :key="item.path">
          <router-link
            class="link"
            tag="a"
            v-if="item.path"
            :to="item.path"
            :key="item.path"
          >{{ item.title }}</router-link>
          <a class="link" v-if="item.link" :href="item.link" target="_blank">{{ item.title }}</a>
        </span>
      </nav>
    </div>
  </div>
</template>
<script>
import { routes } from "@/router";

const routerConf = routes.reduce((acc, next) => {
  if (next.meta && next.meta.title) {
    acc.push({ path: next.path, title: next.meta.title });
  }

  return acc;
}, []);
// routerConf.push({
//   title: "小德社区",
//   link: "//community.zkdntech.com",
// });

export default {
  name: "l-top-bar",
  data() {
    return {
      routerConf,
    };
  },

  computed: {
    active() {
      return this.$route;
    },
  },
};
</script>
<style lang="scss" scoped>
$h: 100px;

.l-top-bar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
  height: $h;
  line-height: $h;
  z-index: 99;

  a {
    color: #fff;
  }
}

.active {
  background: rgba(250, 250, 250, 0.1);
}

.container {
  height: 100%;
}

.logo {
  display: inline-block;
  width: 160px;
  height: 100%;

  .icon {
    display: inline-block;
    width: 156px;
    height: 100%;
    background: url("../assets/logo.png") no-repeat center;
    background-size: 100% auto;
  }
}

.nav-bar {
  float: right;
}

.link {
  box-sizing: border-box;
  display: inline-block;
  // min-width: 110px;
  // padding: auto 5px;
  padding: 0 36px;
  height: 100%;
  text-align: center;
  transition: all 0.3s;
  font-size: $font_size_info_title;

  &:hover {
    background: rgba(250, 250, 250, 0.1);
  }
}
</style>
